import React, { useEffect, useRef, useState } from "react";
import Footer from "../../components/footer";
import "./style.css";
import Timeline from "../../components/timeline";
import { Button } from "../../components/ui/button";
import { Icons } from "../../assets/icons";
import { getSection1 } from "../../api/capabilitiesPage/section1";
import { getSection3 } from "../../api/capabilitiesPage/section3";
import Preclinical from "./Preclinical";
import Cmc from "./Cmc";
import Toxicology from "./Toxicology";
import Adme from "./Adme";
import ProgramManagementAndSupport from "./ProgramManagementAndSupport";
import Regulatory from "./Regulatory";
import ClinicalDesignAndExecution from "./ClinicalDesignAndExecution";
import { config } from "./timelineConfig";
import CapablitiesStack from "./CapablitiesStack";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

const CapabilitiesPage = () => {
  useDocumentTitle("Our Capabilities");
  const [accordionOpenHeader, setAccordionOpenHeader] = useState("");
  const timelineRef = useRef<HTMLDivElement>(null); // Reference for the Timeline container
  // const [isScrollable, setIsScrollable] = useState(false);
  const [loading1, setLoading1] = useState(true);
  // const [loading2, setLoading2] = useState(true);
  // const [loading3, setLoading3] = useState(true);

  const [data1, setData1] = useState<any>();
  // const [data2, setData2] = useState<any>();
  // const [data3, setData3] = useState<any>();

  // const scrollLeft = () => {
  //   if (timelineRef.current) {
  //     timelineRef.current.scrollBy({
  //       left: -150, // Adjust scroll distance as needed
  //       behavior: "smooth", // Smooth scroll behavior
  //     });
  //   }
  // };

  // Function to scroll right
  // const scrollRight = () => {
  //   if (timelineRef.current) {
  //     timelineRef.current.scrollBy({
  //       left: 150, // Adjust scroll distance as needed
  //       behavior: "smooth", // Smooth scroll behavior
  //     });
  //   }
  // };

  // Check if horizontal scroll is present
  // useEffect(() => {
  //   const checkScrollable = () => {
  //     if (timelineRef.current) {
  //       setIsScrollable(
  //         timelineRef.current.scrollWidth > timelineRef.current.clientWidth
  //       );
  //     }
  //   };

  //   checkScrollable(); // Initial check

  //   // Re-check when the window resizes
  //   window.addEventListener("resize", checkScrollable);

  //   return () => window.removeEventListener("resize", checkScrollable);
  // }, [data3]);
  const fetchData = () => {
    getSection1().then((res) => {
      setData1(res.data);
      setLoading1(false);
    });
    // getSection3().then((res) => {
    //   setData3(res.data);
    //   setLoading3(false);
    // });
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="md:pt-12 pt-4">
      {!loading1 && (
        <section className="">
          <div className="grid md:grid-cols-2 md:gap-12 gap-8 items-center md:px-12 px-4">
            <div className="md:hidden">
              <div className="relative h-full w-full ">
                <img
                  className="rounded-[8px]"
                  src={`${process.env.REACT_APP_API_BASE_URL}${data1.Image.url}`}
                  alt={
                    data1?.Image?.alternativeText ?? "capabilities page image"
                  }
                />
                <div className="absolute top-0 left-0 p-4 flex items-center justify-center bg-bg-neutral_rose rounded-[8px]">
                  <div className="text-body-text-lilly_red">
                    <img
                      className="h-10 w-10 object-cover"
                      src={`${process.env.REACT_APP_API_BASE_URL}${data1.Icon.url}`}
                      alt={
                        data1?.Icon?.alternativeText ?? "capabilities page icon"
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h1>
                <div className="md:text-5xl text-3xl tracking-tighter leading-8 font-light">
                  {data1.Header_non_highlighted}&nbsp;
                  <span className="font-semibold">
                    {data1.Header_highlighted}
                  </span>
                </div>
              </h1>
              <div className="my-4 max-w-[40rem]">{data1.Description}</div>
            </div>
            <div className="relative hidden md:block h-full">
              <img
                className="h-full w-full object-cover md:rounded-[6px]"
                src={`${process.env.REACT_APP_API_BASE_URL}${data1.Image.url}`}
                alt={data1?.Image.alternativeText ?? "Capabilities Image"}
              />

              <div className="absolute right-full h-20 w-20 p-5 flex items-center justify-center bg-bg-neutral_rose rounded-[8px]">
                <div className="text-body-text-lilly_red">
                  <img
                    src={`${process.env.REACT_APP_API_BASE_URL}${data1.Icon.url}`}
                    alt={data1?.Icon?.alternativeText ?? "Capabilities Icon"}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="md:hidden my-8">
            {/* {!loading2 && (
                            <img
                                src={`${process.env.REACT_APP_API_BASE_URL}${data2.Image.url}`}
                                alt=""
                                className="w-full h-full"
                            />
                        )} */}
          </div>
        </section>
      )}
      {!loading1 && (
        <section className="mt-48 bg-bg-neutral_rose_tint">
          <div className="md:px-12 px-4 py-12 flex flex-col gap-4">
            <h2 className="md:text-3xl text-2xl font-bold md:tracking-tight md:leading-10 leading-8 mb-8">
              Full Stack of Capabilities
            </h2>
            <CapablitiesStack />
          </div>
        </section>
      )}

      {/* IDP Timeline commented out, for future addition */}
      {/* {!loading3 && (
        <section className="md:mt-24 py-16 md:py-0">
          <div className="md:px-12 px-4">
            <div className="flex flex-col lg:flex-row lg:items-end lg:gap-8 gap-4">
              <div className="text-3xl font-bold leading-10 tracking-tight">
                {data3.Header}
              </div>
              <div className="text-body-text-gray8 font-bold mb-1">
                {data3.Sub_header}
              </div>
            </div>
            <div className="mt-2">{data3.Description}</div>
          </div>
          {isScrollable && (
            <div className="grid grid-cols-2 gap-4 w-full justify-between mb-4 mt-4 md:px-12 px-4">
              <Button onClick={scrollLeft} variant={"outline"}>
                <Icons.ChevronLeft />
              </Button>
              <Button onClick={scrollRight} variant={"outline"}>
                <Icons.ChevronRight />
              </Button>
            </div>
          )}
          <div className="md:px-12 px-4 overflow-auto mt-8" ref={timelineRef}>
            <div className="w-full min-w-[88rem]">
              <Timeline
                config={data3.Timeline}
                // config={config}
              />
            </div>
          </div>
          <div className="w-full flex-wrap flex items-center gap-4 text-sm md:px-12 px-4 my-4">
            <div className="flex gap-2 items-center">
              <div className="h-4 w-4 bg-red-950"></div>
              Milestone
            </div>
            <div className="flex gap-2 items-center">
              <div className="h-4 w-4" style={{ background: "#FFC709" }}></div>
              Pre-Clinical
            </div>
            <div className="flex gap-2 items-center">
              <div className="h-4 w-4" style={{ background: "#F58E7D" }}></div>
              Tox
            </div>
            <div className="flex gap-2 items-center">
              <div className="h-4 w-4 " style={{ background: "#99BFE5" }}></div>
              Regulatory
            </div>
            <div className="flex gap-2 items-center">
              <div className="h-4 w-4" style={{ background: "#8A969E" }}></div>
              CMC
            </div>
            <div className="flex gap-2 items-center">
              <div className="h-4 w-4" style={{ background: "#C6DCD8" }}></div>
              Clinical
            </div>
          </div>
        </section>
      )} */}

      {!loading1 && (
        <section className="mt-16">
          <div className="md:px-12 px-4 flex flex-col gap-4">
            <h2>
              <div className="md:text-3xl text-2xl font-bold md:tracking-tight md:leading-10 leading-8 mb-8">
                Capabilities
              </div>
            </h2>

            <div>
              <div className="text-2xl font-medium my-4">Preclinical</div>
              <div>
                <Preclinical
                  accordionOpenHeader={accordionOpenHeader}
                  setAccordionOpenHeader={setAccordionOpenHeader}
                />
              </div>
            </div>
            <div>
              <div className="text-2xl font-medium my-4">
                Chemistry, Manufacturing & Control (CMC)
              </div>
              <div>
                <Cmc
                  accordionOpenHeader={accordionOpenHeader}
                  setAccordionOpenHeader={setAccordionOpenHeader}
                />
              </div>
            </div>
            <div>
              <div className="text-2xl font-medium my-4">Toxicology</div>
              <div>
                <Toxicology
                  accordionOpenHeader={accordionOpenHeader}
                  setAccordionOpenHeader={setAccordionOpenHeader}
                />
              </div>
            </div>
            <div>
              <div className="text-2xl font-medium my-4">
                Absorption, Distribution, Metabolism & Excretion (ADME)
              </div>
              <div>
                <Adme
                  accordionOpenHeader={accordionOpenHeader}
                  setAccordionOpenHeader={setAccordionOpenHeader}
                />
              </div>
            </div>
            <div>
              <div className="text-2xl font-medium my-4">
                Program Management & Support
              </div>
              <div>
                <ProgramManagementAndSupport
                  accordionOpenHeader={accordionOpenHeader}
                  setAccordionOpenHeader={setAccordionOpenHeader}
                />
              </div>
            </div>
            <div>
              <div className="text-2xl font-medium my-4">Regulatory</div>
              <div>
                <Regulatory
                  accordionOpenHeader={accordionOpenHeader}
                  setAccordionOpenHeader={setAccordionOpenHeader}
                />
              </div>
            </div>
            <div>
              <div className="text-2xl font-medium my-4">
                Clinical Design & Execution
              </div>
              <div>
                <ClinicalDesignAndExecution
                  accordionOpenHeader={accordionOpenHeader}
                  setAccordionOpenHeader={setAccordionOpenHeader}
                />
              </div>
            </div>
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
};

export default CapabilitiesPage;
